// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener('cart:item-added', function (evt) {
  console.log('Item added to the cart');
  // console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('cart:updated', function (evt) {
  console.log('Cart updated');
  // console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener('cart:error', function (evt) {
  console.log('Cart error');
  // console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('quick-cart:open', function (evt) {
  console.log('Quick cart opened');
  // console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener('quick-cart:close', function () {
  console.log('Quick cart closed');
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener('product:variant-change', function (evt) {
  console.log('Product variant changed');
  // console.log(evt.detail.variant);
  var product__attributes_All = document.querySelectorAll(`.variant__attributes`);
  var product__attributes = document.querySelector(`.variant__attributes[data-product-id="${evt.detail.variant.id}"]`);
  if(product__attributes_All){
    for (let index = 0; index < product__attributes_All.length; index++) {
      const element = product__attributes_All[index];
      element.classList.add('hidden');
      if(element.dataset.productId == `${evt.detail.variant.id}`){
        element.classList.remove('hidden')
      }
    }
  }

  
  
  priceManage_PDP(evt);
  sliderMetafield_PDP(evt.detail.variant.id);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener('product:quantity-update', function (evt) {
  console.log('Product quantity updated');
  // console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener('quickview:loaded', function () {
  console.log('Quickview loaded');
});

// This event perform when dom fully loaded.
let metaCustomSliderMobile = null;
let metaCustomSliderDesktop = null;
document.addEventListener('DOMContentLoaded', () => {
  let targetID = document.querySelector("[name=id]");
  metaCustomSliderMobile = document.querySelectorAll('[data-meta-custom-slider-mobile]');
  metaCustomSliderDesktop = document.querySelectorAll('[data-meta-custom-slider-desktop]');
  if(targetID){
    sliderMetafield_PDP(targetID.value);
  }
});

// This function change the variant price as per the current variant.
function priceManage_PDP(evt){
  // Update product variant price on change.
  // Regular price update.
  const preSaleData = document.querySelector('.product__details .product__block--product-header .product__price [data-price]')?.getAttribute("data-pre-sale") ? JSON.parse(document.querySelector('.product__details .product__block--product-header .product__price [data-price]').getAttribute("data-pre-sale")) : null;
  var price = evt.detail.variant.price;
  var compareAtPrice = evt.detail.variant.compare_at_price;
  var isPreSale = false;

  if(preSaleData && Object.keys(preSaleData).length > 0 && preSaleData[evt.detail.variant.id] && preSaleData[evt.detail.variant.id] > 0) {
    price = parseInt(preSaleData[evt.detail.variant.id]);
    compareAtPrice = evt.detail.variant.price;
    isPreSale = true;
  }

  let regular_price = document.querySelector(".product__details .product__block--product-header .product__price [data-price]");
  if(regular_price){ 
    regular_price.textContent = (theme.moneyFormat).replace("{{amount}}", `${price / 100}`);
    regular_price.dataset.price = price / 100;
  }
  // Compare at price update.
  let compare_price = document.querySelector(".product__details .product__block--product-header .product__price [data-compare-price]");
  if(compare_price && compareAtPrice){ 
    compare_price.textContent = (theme.moneyFormat).replace("{{amount}}", `${compareAtPrice / 100}`);
    
    if(isPreSale) return;

    var discountPercentage = ((compareAtPrice - price) / compareAtPrice) * 100;
    if(discountPercentage > 20){
      badge_color = 'badge_30';
    }
    var variant_badge = document.getElementsByClassName(`${evt.detail.variant.id}_badge_discount`);
    if(variant_badge.length > 0){
      for (let index = 0; index < variant_badge.length; index++) {
        variant_badge[index].classList.remove('hidden');
      }
    }else{
      console.log("element not exist.");
      var badge = `<div class="${evt.detail.variant.id}_badge_discount product-badge__wrapper discount-badge ${badge_color}"><span>-${~~discountPercentage}%</span></div>`;
      var discount_badge = document.querySelectorAll(`.PDP_badge`);
      for (let index = 0; index < discount_badge.length; index++) {
        var isMetafieldBadgeStack = discount_badge[index].classList.contains('badges__wrapper--metafield');
        discount_badge[index].insertAdjacentHTML(isMetafieldBadgeStack ? "beforeend" : "afterbegin", badge);
        var exist_badge = discount_badge[index];
        if(!isMetafieldBadgeStack && exist_badge.querySelector('.neu')){
          discount_badge[index].classList.add('neu-in', 'discount-badge-in');
        }
        if(!isMetafieldBadgeStack && exist_badge.querySelector('.bestseller')){
          discount_badge[index].classList.add('bestseller-in', 'discount-badge-in');
        }
        if(!isMetafieldBadgeStack && exist_badge.querySelector('.angebot')){
          discount_badge[index].classList.add('bestseller-in', 'discount-badge-in');
        }
      }
    }
  }else{
    var discount_badge = document.querySelectorAll(`.PDP_badge .discount-badge`);
    for (let index = 0; index < discount_badge.length; index++) {
      discount_badge[index].classList.add('hidden');
    }
  }
}

// This function will play the variant metafield images into the PDP slider for desktop and mobile.
function sliderMetafield_PDP(targetID){
  // update slider image content on change variant.
  let metaCustomSlider = document.querySelectorAll('[data-meta-custom-slider]');
  if(metaCustomSlider.length > 0){ console.log('Slider - initially clear - desktop-mobile');
    var varintID = targetID;
    // Hide initial slider images.  -- Desktop and Mobile
    metaCustomSlider.forEach(function(element){
      element.classList.add("hidden");
    });

    // If thumbnails are existe (means one or more images) find curent variant image and only display them.  -- Desktop
    var metaCustomThumbnail = document.querySelectorAll('[data-meta-custom-thumbnail]');
    if(metaCustomThumbnail.length > 0){ console.log('Slider - thumbnail - desktop');
      metaCustomThumbnail.forEach(function(element){
        element.classList.remove("active");
        (element.getAttribute('data-meta-custom-thumbnail') == `${varintID}_love`) ? element.parentNode.classList.remove("hidden") : element.parentNode.classList.add("hidden");
      });
      // get the first image element slider and display.
      var dataMetaCustomThumbnailElement = document.querySelector(`[data-meta-custom-thumbnail='${varintID}_love']`);
      dataMetaCustomThumbnailElement.classList.add("active");
      dataMetaCustomThumbnailElement.click();
    }

    // if set 'list' or 'grid' it will run separate then thumbnail. -- Desktop
    if(metaCustomSliderDesktop.length > 0){ console.log('Slider - list or grid - desktop');
      var metaCustom_desktop = document.querySelectorAll('[data-meta-custom-slider-desktop]');
      for (var i = metaCustom_desktop.length - 1; i >= 0; i--) {
        var chileElement = metaCustom_desktop[i];
        chileElement.parentNode.removeChild(chileElement);
      }
      // filter current variant and append to the carousel.
      metaCustomSliderDesktop.forEach(function(element){
        if(element.getAttribute('data-meta-custom-slider-desktop') == `${varintID}_love`){ 
          element.classList.remove('hidden');
          if(document.querySelector('.love_slider_meta_2 .product__media-show-more')){
            document.querySelector('.love_slider_meta_2 .product__media-show-more').parentNode.insertBefore(element, document.querySelector('.love_slider_meta_2 .product__media-show-more'));
          }else{
            document.querySelector('.love_slider_meta_2').appendChild(element);
          }
        }
      });
    }

    // If set 'carousel' or 'list' or 'grid' only show current variant images.  -- Mobile
    if(metaCustomSliderMobile.length > 0){ console.log('Slider - carousel or list or grid - Mobile');
      var metaCustom_moble = document.querySelectorAll('[data-meta-custom-slider-mobile]');
      for (var i = metaCustom_moble.length - 1; i >= 0; i--) {
        var chileElement = metaCustom_moble[i];
        chileElement.parentNode.removeChild(chileElement);
      }
      // filter current variant and append to the carousel.
      metaCustomSliderMobile.forEach(function(element){
        if(element.getAttribute('data-meta-custom-slider-mobile') == `${varintID}_love`){ 
          element.classList.remove('hidden');
          if(document.querySelector('.love_slider_meta_1 .product__media-show-more')){
            document.querySelector('.love_slider_meta_1 .product__media-show-more').parentNode.insertBefore(element, document.querySelector('.love_slider_meta_1 .product__media-show-more'));
          }else{
            document.querySelector('.love_slider_meta_1').appendChild(element);
          }
        }
      });
    }
  }
}

//  FAQ and review button scrolling js
document.addEventListener('DOMContentLoaded', () => {
  const classesToCheck = ['faq_btn', 'reviews_btn'];
  document.addEventListener("click", function(event){
    if (classesToCheck.some(className => event.target.classList.contains(className))) {
      if (event.target.classList.contains('faq_btn')) {
        document.querySelector('.collapsible-row-list__inner').scrollIntoView({ behavior: 'smooth' });
      } else if (event.target.classList.contains('reviews_btn')) {
        document.querySelector('.cosmetic_reviews').scrollIntoView({ behavior: 'smooth' });
      }
    }
  });

  function hidePaymentButton(buttonContainer) {
    if (buttonContainer) {
      var buttons = buttonContainer.querySelectorAll('li[data-testid="grid-cell"]');
      buttons.forEach(function (button) {
        var iframe = button.querySelector('iframe.paypalLight');
        if (!iframe) {
          button.style.display = 'none';
        } else {
          button.classList.add('paypal-button-visibility');
        }
      });
    }
  }
  let paymentButtonInterval = setInterval(function () {
    var buttonContainer = document.querySelector('ul[data-shopify-buttoncontainer="true"]');
    if (buttonContainer) {
      hidePaymentButton(buttonContainer);
      clearInterval(paymentButtonInterval);
    }
  }, 50);
});
// ends

/* product assistant improve on quick menu left */

(() => {
  // utils/common.js
  function poll(condition, callback, persistent = false, timeout = 1e4, pollInterval = 25) {
    if (condition()) {
      callback(condition());
    } else if (timeout > 0) {
      setTimeout(() => {
        poll(condition, callback, persistent, persistent ? timeout : timeout - pollInterval, pollInterval);
      }, pollInterval);
    }
  }

  function q(s, o) {
    return o ? s.querySelector(o) : document.querySelector(s);
  }

  // src/Nature-Love/NAL-107/1/info.js
  var ID = "NAL-107";
  var VAR = "1";

  // src/Nature-Love/NAL-107/1/index.js
  function testInfo(testName) {
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[ID] = {
      name: testName || "",
      variation: `${VAR}`,
      logs: []
    };
  }

  function setHeightHeader() {
    poll(
      () => location.pathname.includes('/pages/produkt-assistent') && q('html[style*="--height-header:"]'),
      () => {
        q('html[style*="--height-header:"]').style.setProperty(
          '--height-header',
          `${parseInt(q('html[style*="--height-header:"]').style.getPropertyValue('--height-header').split('px')[0]) + 3}px`
        );
      }
    );
  }

  function checkPage() {
    poll(
      () => location.pathname.includes("/pages/produkt-assistent") && q("#quizStartButton") && sessionStorage.getItem("NAL-107__product-assistant-menu-clicked"),
      () => {
        const intervalId = setInterval(() => {
          if (!q('[aria-label="Modal Overlay Box"]')) {
            q("#quizStartButton").click();
            sessionStorage.removeItem("NAL-107__product-assistant-menu-clicked");
          }
        }, 10);

        setTimeout(() => {
          clearInterval(intervalId);
        }, 5e3);
      }
    );
  }

  function mainJS() {
    testInfo("Optimize product finder display sitewide");
    checkPage();
    setHeightHeader();
  }

  mainJS();
})();
